import z from "zod";

const zGenderSchema = z.enum(["MALE", "FEMALE", "UNDETERMINED"]);
type GenderSchema = z.infer<typeof zGenderSchema>;

export { zGenderSchema };
export type { GenderSchema };
